/* eslint-disable prettier/prettier */
import { SocialNetworks } from '../../emun/social'
import { Languages } from '../../interfaces/common'
import { socialAuthURLs } from '../URLs'
import { apiGet } from '../api'

export interface ISocialNetworkAuthUser {
  socialNetwork: SocialNetworks
  locale?: Languages
  callbackUrl?: string
  appId?: number
  lang?: string
}

export async function SocialAuthModel({ socialNetwork, callbackUrl, appId, lang, locale }: ISocialNetworkAuthUser) {
  const host = socialAuthURLs[socialNetwork]
  const queryParams = {
    callbackurl: callbackUrl ?? '',
    appId: appId ?? '',
    lang: lang ?? '',
    urlreferral: window.location.href,
  }

  const result = await apiGet<object, any>({ path: host, params: queryParams, locale })

  return result
}

export function useSocialNetworkAuthUser() {
  return {
    socialNetworkAuthUser: ({ socialNetwork, callbackUrl, appId, lang, locale }: ISocialNetworkAuthUser) =>
      SocialAuthModel({
        socialNetwork,
        callbackUrl,
        appId,
        lang,
        locale,
      }),
  }
}
